import React from "react";
import { NoteDTO } from "@campgladiator/cg-common.types.types";
import { Card } from "@campgladiator/cgui-core.atoms.card";
import { Divider } from "@campgladiator/cgui-core.atoms.divider";
import { Label } from "@campgladiator/cgui-core.atoms.typography";
import { Buttons } from "./components/Buttons";
import { ChatBubble } from "./components/ChatBubble";
import { MessageInput } from "./components/MessageInput";
import styles from "./Note.module.scss";
import { useWithNote } from "./";

export type NoteProps = {
  adminId: string;
  createdBy: NoteDTO["createdBy"];
  handleCancelAddNewNote: (id: string) => Promise<boolean>;
  handleDeleteNote: (id: string) => Promise<boolean>;
  handleEditNote: (id: string, note: string) => Promise<boolean>;
  handleSaveNewNote: (id: string, note: string) => Promise<boolean>;
  note: NoteDTO["note"];
  noteId: string;
  timestampDate: string;
};

const Note = ({
  adminId,
  createdBy,
  note,
  noteId,
  timestampDate,
  handleCancelAddNewNote,
  handleDeleteNote,
  handleEditNote,
  handleSaveNewNote,
}: NoteProps) => {
  const {
    authorFullName,
    buttons,
    isInputVisible,
    messageInputProps,
    formattedDate,
    formattedTime,
  } = useWithNote({
    createdBy,
    adminId,
    timestampDate,
    note,
    noteId,
    handleCancelAddNewNote,
    handleDeleteNote,
    handleEditNote,
    handleSaveNewNote,
  });

  return (
    <Card flat className={styles.container}>
      <div className={styles.timestamp}>
        <Label>{formattedDate}</Label>
      </div>
      <Divider className={styles.divider} />
      <div className={styles.content}>
        {note && (
          <ChatBubble
            authorFullName={authorFullName}
            note={note}
            formattedTime={formattedTime}
          />
        )}
        {isInputVisible && <MessageInput {...messageInputProps} />}
        <Buttons buttons={buttons} />
      </div>
    </Card>
  );
};

export default Note;
